import React from "react";
import { Row, Col } from "antd";

import IndividualUserTimeline from "../../../components/report/individual_user/IndividualUserTimeline";
import Layout from "../../../components/layout/Layout";
import RecentVisitFeedback from "../../../components/report/individual_user/RecentVisitFeedback";
import StressIndividualUser from "../../../components/report/individual_user/StressIndividualUser";
import TableUserSessions from "../../../components/report/individual_user/TableUserSessions";
import { VisualTotalInfomation } from "../../../components/report/individual_user/TotalInformation";
import UserInformation from "../../../components/report/individual_user/UserInformation";

const IndividualUserComp = ({ id, data }) => (
	<div>
		<Row gutter={16}>
			<Col xl={24}>
				<Row gutter={16}>
					<Col span={12}>
						<UserInformation
							employee_information={data ? data.employee_information : null} />
					</Col>
					<Col span={12}>
						<VisualTotalInfomation
							visualColorKey={id}
							total={data ? data.stress_results.length : 0}
							description='Total test session' />
						<VisualTotalInfomation
							visualColorKey={id}
							total={data ? data.employee_sessions.length : 0}
							description='Total counseling' />
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<StressIndividualUser
							visualColorKey={id}
							title="Stress level from provider"
							stress={data ? data.stress_provider : null}
							provider={true}
							chartId={`chart_${id}_provider`} />
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<StressIndividualUser
							visualColorKey={id}
							title="Stress test results"
							stress={data ? data.stress_results : null}
							provider={false}
							chartId={`chart_${id}_user`} />
					</Col>
				</Row>
			</Col>
			<Col xl={24}>
				<Row>
					<Col span={24}>
						<TableUserSessions
							visualColorKey={id}
							employee_sessions={data ? data.employee_sessions : null} />
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<RecentVisitFeedback
							visualColorKey={id}
							visit_feedback={data ? data.visit_feedback : []} />
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<IndividualUserTimeline
							visualColorKey={id}
							timeline={data ? data.timeline : []} />
					</Col>
				</Row>
			</Col>
		</Row>
	</div>
);

export default IndividualUserComp;


// WEBPACK FOOTER //
// ./src/components/report/individual_user/IndividualUserComp.js